var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseCircleIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#75777B",
    d: "M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12M6.102 6.102a.56.56 0 0 1 .794 0l1.102 1.101 1.101-1.101a.562.562 0 0 1 .795.795l-1.102 1.1L9.894 9.1a.562.562 0 0 1-.795.795L7.998 8.792 6.896 9.894a.562.562 0 0 1-.795-.795l1.102-1.101-1.101-1.102a.56.56 0 0 1 0-.794"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseCircleIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-circle-icon.e6777fa549db087aa7460cf19dd393fd.svg";